<template>
        <div class="modal-mask" @click="$emit('close')" id="record-modal">
          <div class="modal" id="caseModal" tabindex="-1" role="dialog" aria-labelledby="caseModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
              <div class="modal-content" @click.stop>
                <div class="modal-header">
                  <div class="text-left">
                    <h3 class="modal-title">{{ record.description }}</h3>
                  </div>
                  <button type="button" class="close" @click="$emit('close')" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="body-footer">
                  <div class="modal-body">
                    <swiper v-if="record.recordpics&&record.recordpics.length>0" :options="swiperOption" :key="record.id">
                      <swiper-slide v-for="img in record.recordpics" :key="img">
                        <img class="casePic" :src="img">
                      </swiper-slide>
                      <div class="swiper-pagination" slot="pagination"></div>
                      <div class="swiper-button-prev" slot="button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z"></svg></div>
                      <div class="swiper-button-next" slot="button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z"></svg></div>
                    </swiper>
                    <img v-else class="casePic" :src="record.img">
                  </div>
                  <div class="modal-footer justify-content-start">
                      <table class="table table-bordered case-table">
                          <!-- <tr>
                              <th>聯絡電話</th>
                              <td>{{ record.phone }}</td>
                          </tr> -->
                          <tr>
                              <th>基地位置</th>
                              <td>{{ record.address }}</td>
                          </tr>
                          <tr>
                              <th>產品規劃</th>
                              <td>{{ record.plan }}</td>
                          </tr>
                          <tr>
                              <th>建築外觀</th>
                              <td>{{ record.apperance }}</td>
                          </tr>
                          <tr>
                              <th>公設景觀</th>
                              <td>{{ record.public_view }}</td>
                          </tr>
                          <tr>
                              <th>工程營造</th>
                              <td>{{ record.construction_company }}</td>
                          </tr>
                          <tr>
                              <th>結構設計</th>
                              <td>{{ record.structure_designer }}</td>
                          </tr>
                          <!-- <tr>
                              <th>分享</th>
                              <td>
                                <a @click="socialShare('fb')" class="social-icon"><i class="fab fa-facebook-f fa-2x"></i>
                                </a>
                                <a @click="socialShare('line')" class="social-icon"><i class="fab fa-line fa-2x"></i>
                                </a>
                                <a @click="socialShare('whatsapp')" class="social-icon"><i class="fab fa-whatsapp fa-2x"></i>
                                </a>
                                <a @click="socialShare('weibo')" class="social-icon"><i class="fab fa-weibo fa-2x"></i>
                                </a>
                                <a @click="socialShare('twitter')" class="social-icon"><i class="fab fa-twitter fa-2x"></i>
                                </a>
                              </td>
                          </tr> -->
                      </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'RecordModal',
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    record: Object,
  },
  data() {
    return {
      swiperOption: {
        effect: 'fade',
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      }
    }
  },
}
</script>

<style scoped>
.modal-default-button {
  float: right;
}
th {
  text-align: center;
  width: 110px;
}
td {
  text-align: left;
}
.hidden {
  visibility: hidden;
}
#caseModal {
  display: block;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
}
.modal-mask.noshow {
  display: none;
}
.modal-header {
  padding-bottom: 0.5rem;
}
.modal-body {
  overflow-y: visible;
  background-color: #222;
  padding: 0;
  height: 42vh;
}
.modal-footer {
  overflow-y: auto;
  display: block;
  height: 42vh;
}
.casePic{
  width: 100%;
  height: 42vh;
}
@media (min-width: 992px) {
  .modal-dialog {
    max-width: 95%;
  }
  .modal-body {
    overflow-y: visible;
    background-color: #222;
    width: 50%;
    height: 83.1vh;
  }
  .modal-footer {
    width: 50%;
    height: 83.1vh;
  }
  .body-footer {
    display: flex;
  }
  .casePic{
    height: 83.1vh;
  }
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color:  rgba(235, 159, 18, 0.842);;
}
.swiper-button-next, .swiper-button-prev {
    background-image: none;
    fill: rgba(235, 159, 18, 0.842);
}
.social-icon {
  margin-right: 4%;
}
.case-table {
  font-size: 1.3rem;
}
</style>